import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 字段类型
    TEMPLATE_FIELDS_TYPE: computed(() => (
      store.state.label.data.TEMPLATE_MANAGEMENT?.TEMPLATE_FIELDS_TYPE
    )),
    // 所属字段
    TEMPLATE_TYPE: computed(() => (
      store.state.label.data.TEMPLATE_MANAGEMENT?.TEMPLATE_TYPE
    )),
    // 模板状态
    TEMPLATE_STATE: computed(() => (
      store.state.label.data.TEMPLATE_MANAGEMENT?.TEMPLATE_STATE
    )),
    // 是否必填
    TEMPLATE_FIELD_MUST: computed(() => (
      store.state.label.data.TEMPLATE_MANAGEMENT?.TEMPLATE_FIELD_MUST
    )),
    // 七牛域名
    QI_NIU_DOMAINS: computed(() => (
      store.state.label.data.QI_NIU_DOMAINS
    )),
    // 搜索表单
    SEARCH_FORM: computed(() => (
      store.state.searchForm.data
    )),
    SET_SEARCH: computed(() => (
      store._mutations.SET_SEARCH
    )),
    // 搜索表单时间
    SEARCH_FORMDAY: computed(() => (
      store.state.searchForm.date
    )),
    SET_SEARCHDAY: computed(() => (
      store._mutations.SET_SEARCHDAY
    )),
    FIELD_CLASS: computed(() => (
      store.state.label.data.FIELD?.FIELD_CLASS
    )),
    FIELDS_TYPE: computed(() => (
      store.state.label.data.FIELD?.FIELDS_TYPE
    )),
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
